import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Controller, EffectFade, Manipulation } from "swiper/modules";

const cardGallery = () =>({
    galleryThumbnail: null,
    galleryMain: null,
    sliderInitialized: false,
    thumbnailSliderInitialized: false,
    init() {
        this.imageGallery();
    },
    imageGallery() {
        this.$nextTick(()=>{
            let gallery_thumbnail_swiper = this.$el.querySelector('.product-thumbnails-slider');
            let gallery_main_swiper = this.$el.querySelector('.product-gallery-slider');
            if (gallery_thumbnail_swiper) {
                this.galleryThumbnail = new Swiper(gallery_thumbnail_swiper, {
                    modules: [Navigation, Controller, Manipulation, Thumbs],
                    ...{
                        slidesPerView: 'auto',
                        freeMode: true,
                        watchSlidesProgress: true,
                        breakpoints: {
                            0: {

                            },
                            1024: {

                            }
                        }
                    }
                });
            }

            this.galleryMain = new Swiper(gallery_main_swiper, {
                modules: [Navigation, Pagination, Scrollbar, Controller, Thumbs],
                ...{
                    grabCursor: true,
                    spaceBetween: 1,
                    navigation: {
                        nextEl: '[data-main-slider-arrow-next]',
                        prevEl: '[data-main-slider-arrow-prev]',
                    },
                    thumbs:{
                        swiper: this.galleryThumbnail && this.galleryThumbnail
                    },
                    breakpoints: {
                        0:{
                            slidesPerView: 1
                        },
                        990: {
                            slidesPerView: 1
                        },
                    }
                }

            });
            this.sliderInitialized = true
            this.thumbnailSliderInitialized = true
        })
    }
})

export default cardGallery;
